import "./style.scss";

import React from "react";
import breakfast from "./images/breakfast.jpg";
import cards from "./images/cards.jpg";
import cardsout from "./images/cardsout.jpg";
import data from "./images/data.jpg";
import details from "./images/details.jpg";
import door from "./images/door.jpg";
import infopayment from "./images/infopayment.jpg";
import number from "./images/number.jpg";
import payment from "./images/payment.jpg";
import recipe from "./images/recipe.jpg";
import search from "./images/search.jpg";
import select from "./images/select.jpg";
import start from "./images/start.jpg";
import touch from "./images/touch.jpg";
import { useData } from "../../dataProvider";

export default function Checkin() {
  const { lang } = useData();

  const items = [
    {
      reverse: true,
      image: start,
      title: "Einleitung",
      description:
        "<p>Im Batschari Palais haben Sie die Möglichkeit, komplett selbstständig einzuchecken.</p><p>So funktioniert's:</p>",
    },
    {
      reverse: false,
      image: touch,
      number: "1",
      description: "<p>Bildschirm berühren.</p>",
    },
    {
      reverse: true,
      image: select,
      number: "2",
      description:
        "<p><b>CHECK-IN</b> auswählen und Datenschutzerklärung akzeptieren.</p>",
    },
    {
      reverse: false,
      image: number,
      number: "3",
      description:
        "<p>Check-In-Prozess anhand der Bestätigunsnummer oder des Namens starten – wir empfehlen den Prozess per Bestätigungsnummer.</p>",
    },
    {
      reverse: true,
      image: search,
      number: "4",
      description:
        "<p>Bestätigungsnummer eingeben und <b>RESERVIERUNG SUCHEN</b>.</p>",
    },
    {
      reverse: false,
      image: details,
      number: "5",
      description:
        "<p>Buchungsdetails werden angezeigt, <b>CHECK-IN</b> auswählen.</p>",
    },
    {
      reverse: true,
      image: breakfast,
      number: "6",
      description:
        "<p>Gegebenenfalls Frühstück nachbuchen über <b>HINZUFÜGEN</b>, oder falls nicht gewünscht, einfach mit <b>BESTÄTIGEN</b> weiterklicken.</p>",
    },
    {
      reverse: false,
      image: data,
      number: "7",
      description:
        "<p>Persönliche Daten eingeben und <b>BESTÄTIGEN</b> klicken.</p>",
    },
    {
      reverse: true,
      image: infopayment,
      number: "8",
      description:
        "<p>Das System informiert über noch zu zahlende Beträge – <b>BESTÄTIGEN UND BEZAHLEN</b> klicken.</p>",
    },
    {
      reverse: false,
      image: payment,
      number: "9",
      description:
        "<p>Zahlung am Kartenterminal vornehmen – die Quittung wird automatisch erstellt.</p>",
    },
    {
      reverse: true,
      image: cards,
      number: "10",
      description: "<p>Anzahl der gewünschten Zimmerkarten auswählen.</p>",
    },
    {
      reverse: false,
      image: cardsout,
      number: "11",
      description:
        "<p>Zimmerkarten werden erstellt und automatisch ausgeworfen.</p>",
    },
    {
      reverse: true,
      image: recipe,
      number: "12",
      description: "<p>Sie erhalten einen Beleg mit Ihrer Zimmernummer.</p>",
    },
    {
      reverse: false,
      image: door,
      number: "13",
      description:
        "<p>Mit der Zimmerkarte die Eingangstür am Sensor öffnen.</p>",
    },
  ];
  const itemsEN = [
    {
      reverse: true,
      image: start,
      title: "Introduction",
      description:
        "<p>At the Batschari Palais, you have the opportunity to check in completely independently.</p><p>Here’s how it works:</p>",
    },
    {
      reverse: false,
      image: touch,
      number: "1",
      description: "<p>Touch the screen.</p>",
    },
    {
      reverse: true,
      image: select,
      number: "2",
      description:
        "<p>Select <b>CHECK-IN</b> and accept the privacy policy.</p>",
    },
    {
      reverse: false,
      image: number,
      number: "3",
      description:
        "<p>Start the check-in process using your booking number or name – we recommend using the booking number.</p>",
    },
    {
      reverse: true,
      image: search,
      number: "4",
      description:
        "<p>Enter the booking number and select <b>SEARCH RESERVATION</b>.</p>",
    },
    {
      reverse: false,
      image: details,
      number: "5",
      description:
        "<p>Your booking details will appear – select <b>CHECK-IN</b>.</p>",
    },
    {
      reverse: true,
      image: breakfast,
      number: "6",
      description:
        "<p>If desired, add breakfast by clicking <b>ADD</b>, or continue without by selecting <b>CONFIRM</b>.</p>",
    },
    {
      reverse: false,
      image: data,
      number: "7",
      description: "<p>Enter your personal data and click <b>CONFIRM</b>.</p>",
    },
    {
      reverse: true,
      image: infopayment,
      number: "8",
      description:
        "<p>The system will show any outstanding charges – click <b>CONFIRM AND PAY</b>.</p>",
    },
    {
      reverse: false,
      image: payment,
      number: "9",
      description:
        "<p>Make the payment using the card terminal – the receipt will be generated automatically.</p>",
    },
    {
      reverse: true,
      image: cards,
      number: "10",
      description: "<p>Select the number of room cards you would like.</p>",
    },
    {
      reverse: false,
      image: cardsout,
      number: "11",
      description:
        "<p>The room cards will be created and dispensed automatically.</p>",
    },
    {
      reverse: true,
      image: recipe,
      number: "12",
      description: "<p>You will receive a receipt with your room number.</p>",
    },
    {
      reverse: false,
      image: door,
      number: "13",
      description:
        "<p>Use the room card to open the entrance door by holding it to the sensor.</p>",
    },
  ];

  const itemLang = lang === "de" ? items : itemsEN;

  return (
    <div className="checkin">
      {itemLang &&
        itemLang.map((item, index) => {
          return (
            <div
              className="checkin-grid"
              key={index}
              style={{
                flexDirection: item.reverse ? "row-reverse" : "row",
              }}
            >
              <div className="checkin-grid-item">
                {item.number && (
                  <h2 className="checkin-number">{item.number}.</h2>
                )}
                <img
                  src={item.image}
                  alt={item.title || `Step ${item.number}`}
                />
              </div>
              <div className="checkin-grid-item content">
                {item.number && (
                  <h2 className="checkin-number">{item.number}.</h2>
                )}
                {item.title && <h2 className="checkin-title">{item.title}</h2>}
                <div dangerouslySetInnerHTML={{ __html: item.description }} />
              </div>
            </div>
          );
        })}
    </div>
  );
}
